import { MobiDocument } from './MobiDocument';

export class ClasseScolaireNiveauDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private classescolaire_id: number;
    private niveauscolaire_id: number;

    constructor(classeScolaireNiveau: any) {
        super();
        this._id = classeScolaireNiveau._id;
        this._rev = classeScolaireNiveau._rev;
        this.classescolaire_id = classeScolaireNiveau.classescolaire_id;
        this.niveauscolaire_id = classeScolaireNiveau.niveauscolaire_id;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getClassescolaire_id(): number {
        return this.classescolaire_id;
    }

    public setClassescolaire_id(classescolaire_id: number): void {
        this.classescolaire_id = classescolaire_id;
    }

    public getNiveauscolaire_id(): number {
        return this.niveauscolaire_id;
    }

    public setNiveauscolaire_id(niveauscolaire_id: number): void {
        this.niveauscolaire_id = niveauscolaire_id;
    }

}